import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import KenColors from '../../themes/KenColors';
import countryCodes from '../../json/countryISDCode.json';
import { useHistory } from 'react-router-dom';
import { routes } from '../../utils/urls';
import configContext from '../../utils/config';
import { getLayout } from './helper';
import { GLOBAL } from '../../utils/constants';

const options = countryCodes.codes;

const useStyles = makeStyles((theme) => ({
  detailContent: {
    fontSize: 16,
    color: KenColors.neutral700,
  },
  header: {
    padding: 8,
    boxShadow: `0px 0px 9px ${theme.palette.KenColors.shadowColor}`,
  },
  logoImg: {
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  banner: {
    alignItems: 'normal',
    height: '600px',
    position: 'relative',
  },
  bannerImg: {
    width: '100%',
  },
  formDetails: {
    padding: 16,
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
    [theme.breakpoints.down('sm')]: {
      position: 'initial',
      padding: 12,
    },
  },
  otpLabel: {
    fontWeight: 600,
    textAlign: 'start',
    fontSize: 20,
  },
  agreeInfo: {
    fontSize: 14,
  },
  footer: {
    padding: 10,
  },
  getOtpContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  boxParent: {
    position: 'relative',
  },
  carouselwrap: {
    width: '100%',
  },
}));

export default function LandingPage(props) {
  const [open, setOpen] = React.useState(false);
  const [signActive, setSignActive] = useState(true);
  const [existingActive, setExistingActive] = useState(false);
  const { handleSnackbarOpen } = props;

  const [user] = useState({ firstName: '', lastName: '' });
  const history = useHistory();
  const { config } = React.useContext(configContext);

  const handleClose = (event, reason, submitted) => {
    setOpen(false);
  };
  const classes = useStyles();

  useEffect(() => {
    const contactID = localStorage.getItem('contactID');
    if (contactID) {
      history.push(routes.programs);
    }
  }, [history]);

  return config && config.banner && config.banner.layout ? (
    <>{getLayout(`${config.banner.layout}`)}</>
  ) : (
    <>{getLayout(`${GLOBAL.LAYOUTS.DEFAULT}`)}</>
  );
}